import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@shopify/polaris';
import { HomeIcon } from '@shopify/polaris-icons';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const HomeServicesSidebar = () => {
  const location = useLocation();
  const { user } = useContext(AuthenticationContext);
  const hasAdminModule = user?.modules?.some((module) => module.value === 'home_services' && parseInt(module.tier) > 2);

  const adminItems = [
    { url: '/home_services/reports', disabled: false, label: 'Completed Reports' },
    { url: '/home_services/customer_notification', disabled: false, label: 'Customer Notification' },
    { url: '/home_services/alert_notifications', disabled: false, label: 'Alert Notifications' },
  ];

  const subNavigationItems = [
    { url: '/home_services/upcoming_inspections', disabled: false, label: "Today's Inspections" },
    ...(hasAdminModule ? adminItems : []),
  ];

  const navigationItems = [
    {
      label: 'Home Services',
      url: '/home_services/upcoming_inspections',
      icon: HomeIcon as any,
      matches: true,
      subNavigationItems,
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default HomeServicesSidebar;
